import { ReactNode } from "react";
import { Sidebar } from "247factorynet-packages";
import "247factorynet-packages/dist/index.css";
import { ReactComponent as Logo } from "assets/Svgs/logo.svg";

import Header from "./Header";
import { useNavigate } from "react-router-dom";
import { CalendarMonth } from "@mui/icons-material";
import ErrorBoundary from "./ErrorBoundary";
import TabletHeader from "./TabletHeader";
import { Divider } from "@mui/material";
import { sideBarMenuItems } from "utils/dummy";
import { useBoundStore } from "store/store";

interface LayoutProps {
  children: ReactNode;
}

function Layout({ children }: LayoutProps) {
  
  const navigate = useNavigate();
  const lang: any = useBoundStore((state) => state.lang);

  return (
    <>
      <div className="tabletHeaderWrapper">
        <TabletHeader />
        <Divider />
      </div>
      <div className="layout" id="layout">
        <div className="layoutSidebar">
          <div
            className="logo"
            style={{ minHeight: "11.7vh" }}
            onClick={() => {
              navigate("/qualitymanagement");
            }}
          >
            <Logo />
          </div>
          <Sidebar data={sideBarMenuItems(lang)} navigateToFirstChild />
        </div>
        <div className="flexContent">
          <div className="mainHeader">
            {" "}
            <Header />
          </div>
          <div className="tabletSideBar">
            <Sidebar data={sideBarMenuItems(lang)} navigateToFirstChild />
          </div>
          <div className="children">
            <ErrorBoundary>{children}</ErrorBoundary>
          </div>
        </div>
      </div>
    </>
  );
}

export default Layout;
